import { createGlobalStyle } from 'styled-components'

/**
 * @Global: This is a global style that is applied to the entire app.
 * ONLY use this for styles that are truly global and not specific to a component.
 */

export const AppGlobalStyles = createGlobalStyle`
  // Smooth scroll for browsers that support it
  body {
    scroll-behavior: smooth;
  }


  // override sparkplug base style
  section {
    margin-bottom: 0;
  }

  // over-writes base font size for the header & footer so that sparkplug and design-system-foundations don't clash
  .atc-foundation-header,
  .footer,
  .form-housing-test {
    @media (max-width: 48em) and (min-width: 0em) {
      font-size: 0.875em;
    }
  }

  .atc-modal {
    max-width: 350px;
  }

  .atds-field__label.visuallyhidden {
    position: absolute;
  }
    
  @keyframes react-loading-skeleton {
    100% {
        transform: translateX(100%);
    }
  }

  // TODO: migrate to ATDS skeleton solution - styles from 3rd party library, react-loading-skeleton
  .react-loading-skeleton {
    --base-color: #ebebeb;
    --highlight-color: #f5f5f5;
    --animation-duration: 1.5s;
    --animation-direction: normal;
    --pseudo-element-display: block; /* Enable animation */

    background-color: var(--base-color);

    width: 100%;
    border-radius: 0.25rem;
    display: inline-flex;
    line-height: 1;

    position: relative;
    user-select: none;
    overflow: hidden;
    z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */
  }

  .react-loading-skeleton::after {
    content: ' ';
    display: var(--pseudo-element-display);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(
      90deg,
      var(--base-color),
      var(--highlight-color),
      var(--base-color)
    );
    transform: translateX(-100%);

    animation-name: react-loading-skeleton;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }

  @media (prefers-reduced-motion) {
    .react-loading-skeleton {
      --pseudo-element-display: none; /* Disable animation */
    }
  }
`
